export default {
  title: 'Půjčte si jednoduše, férově i bez banky',
  // eslint-disable-next-line max-len
  desc: 'Nejste na to sami! Jsme přední poskytovatel nebankovních úvěrů s licencí ČNB. Na trhu působíme už 11 let. Během této doby jsme vyřešili finanční situaci mnohým našim klientům. Přidejte se k nim i Vy.',
};
